import localization from 'localization';
import { ServiceRequestStatusEnum } from 'domains-work-order-constants';

const VALID_SERVICE_REQUEST_STATUSES = new Set<string>(
  Object.values(ServiceRequestStatusEnum)
);

/**
 * Type predicate to check if a value is a valid ServiceRequestStatusEnum
 */
function isValidServiceRequestStatus(
  status: string | ServiceRequestStatusEnum | undefined
): status is ServiceRequestStatusEnum {
  if (!status) return false;

  return VALID_SERVICE_REQUEST_STATUSES.has(status);
}

/**
 * Gets the translated status label for service requests
 * @param status - The service request status (enum value or string)
 * @returns The translated label, or undefined if status is invalid or falsy
 */
export function getServiceRequestStatusLabel(
  status?: string | ServiceRequestStatusEnum
): string | undefined {
  if (!isValidServiceRequestStatus(status)) {
    return undefined;
  }

  const statusKey = status.replace(/\s/g, '').toLowerCase();
  const i18n = localization.cloneInstance();

  return i18n.t(`shared.workOrders.serviceRequests.status.${statusKey}`);
}
